import * as React from "react";
import classNames from "classnames";

export interface IAccordionProps {
    className?: string;
}

const Accordion: React.FC<IAccordionProps> = props => {
    const rootClasses = classNames("accordion", props.className);
    return <div className={rootClasses}>{props.children}</div>;
};

export default Accordion;
